import { jsx as _jsx } from "react/jsx-runtime";
import { EventCategory } from "@/types/events";
import { Activity, BrickWall, CloudRainWind, Droplets, Flame, FlaskConical, Layers, TrendingDown, WavesHorizontal, Wind, } from "lucide-react";
const iconMap = {
    [EventCategory.NIVEL_RIOS]: Droplets,
    [EventCategory.AREA_ALAGAMENTO]: WavesHorizontal,
    [EventCategory.CHUVAS]: CloudRainWind,
    [EventCategory.BARRAGENS]: BrickWall,
    [EventCategory.VENDAVAL]: Wind,
    [EventCategory.INCENDIO]: Flame,
    [EventCategory.DESLIZAMENTO]: TrendingDown,
    [EventCategory.PERDA_SOLO]: Layers,
    [EventCategory.PRODUTOS_QUIMICOS]: FlaskConical,
    [EventCategory.TREMOR]: Activity,
};
export const getCategoriaIcon = (categoria, size = 40, color = "black", strokewidth = 2) => {
    const Icon = iconMap[categoria];
    if (!Icon)
        return null;
    return _jsx(Icon, { size: size, strokeWidth: strokewidth, color: color });
};
